// extracted by mini-css-extract-plugin
module.exports = {"amount":"BalanceDue_amount__38FpJ","list":"BalanceDue_list__1qP75","listRow":"BalanceDue_listRow___6XkJ","total":"BalanceDue_total__3N9-R"};